import type { UIStrings } from './en';

export const fr: UIStrings = {
  'site.title': 'DopeJs — des outils open source pour le développement avec des agents',
  'site.description':
    'DopeJs conçoit des outils open source pour le développement nativement assisté par IA : runtimes d’agents, agents de code en terminal, outillage d’environnement CLI et moteurs de rendu Canvas.',

  'nav.projects': 'Projets',
  'nav.about': 'À propos',
  'nav.github': 'GitHub',
  'nav.skip': 'Aller au contenu',
  'nav.theme': 'Thème',
  'nav.language': 'Langue',

  'hero.eyebrow': 'open source · développé au grand jour',
  'hero.title': 'Des outils pour le développement natif avec l’IA.',
  'hero.body':
    'DopeJs est un petit ensemble de projets open source articulés autour d’une question : à quoi ressemblent les logiciels que vous utilisez chaque jour lorsque les agents font partie de la boucle ? Runtimes d’agents, agents de code en terminal, outillage d’environnement CLI, moteurs de rendu Canvas — tout est développé publiquement.',
  'hero.cta.projects': 'Voir les projets',
  'hero.cta.github': 'Voir sur GitHub',
  'hero.count': 'projets',

  'projects.title': 'Projets',
  'projects.repo': 'Dépôt',
  'projects.homepage': 'Site web',
  'projects.install': 'Installer',
  'projects.copy': 'Copier',
  'projects.copied': 'Copié',
  'projects.details': 'Détails',

  'status.stable': 'Publié',
  'status.active': 'Développement actif',
  'status.early': 'Précoce — pas prêt pour la production',
  'status.design': 'Phase de conception',

  'project.back': 'Tous les projets',
  'project.overview': 'Vue d’ensemble',
  'project.highlights': 'Ce qu’il fait',
  'project.getStarted': 'Démarrer',
  'project.requirements': 'Prérequis',
  'project.facts': 'En bref',
  'project.facts.status': 'Statut',
  'project.facts.languages': 'Langages',
  'project.facts.license': 'Licence',
  'project.facts.noLicense': 'Aucune pour l’instant',
  'project.links': 'Liens',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': 'Précédent',
  'project.next': 'Suivant',

  'about.title': 'À propos de DopeJs',
  'about.body':
    'Tout est développé au grand jour, sur GitHub. Les issues et les pull requests sont les bienvenues sur n’importe quel dépôt — tout comme les retours honnêtes signalant que quelque chose ne fonctionne pas encore. Plusieurs de ces projets sont en préversion par choix ; lorsque c’est le cas, le projet le dit.',
  'about.cta': 'Suivre l’organisation sur GitHub',

  'footer.built': 'Construit avec React et Vite. Sources sur GitHub.',
  'footer.rights': 'DopeJs',
  'footer.translations': 'Traductions générées automatiquement — les corrections sont bienvenues.',
};
